import { Injectable } from "@angular/core";
import { User } from "../model/user.model";
import { Setting } from "../setting";
import { BaseService } from "./base.services";
import { UserService } from "./user.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    public setting: Setting,
    public baseService: BaseService<any>,
    public userService: UserService
  ) {}

  login(user: User): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService.post(this.setting.Endpoint.Users, user).subscribe(
        (response) => {
          if (response.token != undefined) {
            this.userService.setUser(response);
            resolve("Login Exitoso");
          } else {
            reject(response.message);
          }
        },
        (error) => {
          reject(error.error.message);
        }
      );
    });

    return promesa;
  }

  sendEmail(email: string): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService
        .post("/v1/users/forgot-password", { email: email })
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error.error.message);
          }
        );
    });

    return promesa;
  }

  verifyCode(email: string, code: string): Promise<any> {
    let promesa = new Promise((resolve, reject) => {
      this.baseService
        .post("/v1/users/validate-code", { email: email, code: code })
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error.error.message);
          }
        );
    });

    return promesa;
  }

  changePassword(
    email: string,
    code: string,
    newPassword: string
  ): Promise<any> {
    const body = {
      email: email,
      code: code,
      password: newPassword,
    };
    console.log(body);
    let promesa = new Promise((resolve, reject) => {
      this.baseService.post("/v1/users/reset-password", body).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error.error.message);
        }
      );
    });

    return promesa;
  }
}
